import { BROKERAGE_TRADOVATE } from '../utils/constants';
import { apiRequest } from "../utils/apiClient";

const buildConnectionBody = (formData) => {
    const splitDate = new Date().toString().split(' ');
    const timezoneOffset = Number(splitDate[5].substring(3, 6));

    return {
        broker: BROKERAGE_TRADOVATE,
        username: formData.tradovateUsername,
        password: formData.tradovatePassword,
        appId: formData.tradovateAppId,
        key: formData.tradovateKey,
        deviceID: formData.tradovateDeviceID,
        chl: formData.tradovateCHL,
        tradovateAccountType: formData.tradovateAccountType,
        accountType: formData.tradovateAccountType,
        autoConnect: formData.autoConnect,
        timezoneOffset,
        accountName: formData.accountName,
    };
};

export const connectToTradovate = async (formData, userId, token) => {
    const body = buildConnectionBody(formData);
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId
    };
        try {
            return await apiRequest('post', '/algo/demo/data/start', '/api/v2/data/start', {
                headers, params, body,
            });
        } catch (error) {
            console.log(error.message);
            alert("Error Connecting. Try Again");
            return error.message;
        }
};

export const disconnectFromTradovate = async (connectionName, buid, userId, token, formData, setFormData) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId,
        buid: buid
    };
    try {
        await apiRequest('get', '/algo/demo/data/stop', '/api/v2/data/stop', {
            headers, params,
        });

        setFormData(previousInputs => ({ ...previousInputs, isConnected: false }));
        //Find the item in the array to remove
        let accounts = [];
        for (let i = 0; i < formData.accountStatus.length; i++) {
            if (formData.accountStatus[i].name !== connectionName) {
                accounts.push(formData.accountStatus[i]);
            }
        }
        setFormData(previousInputs => ({ ...previousInputs, accountStatus: accounts }));
        alert(`You Have Removed Connection: ${connectionName}`);
    } catch (error) {
        console.log(error.message);
        alert("Error Removing Connection. Try Again");
        return error.message;
    }
};